export interface GeoLocation {
  address: string;
  latitude: number;
  longitude: number;
}
